import React, {FC} from 'react';
import styled from 'styled-components';

import {ChromelessButton, ChromelessButtonProps} from './chromelessButton';

interface TransparentButtonProps extends ChromelessButtonProps {
  isBig?: boolean;
}

const StyledTransparentButtonContentDiv = styled.div<{$isBig?: boolean}>`
  display: flex;
  align-items: center;

  height: 26px;
  padding: 6px 12px;
  color: #367fee;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: rgba(93, 105, 133, 0.1);
    border-radius: 13px;
  }

  ${(p) =>
    p.$isBig &&
    `
      height: 30px;
      font-size: 14px;
      line-height: 30px;
      padding: 0 14px;
      border-radius: 16px;
    `}
`;

export const TransparentButton: FC<TransparentButtonProps> = (props) => {
  const {children, isBig} = props;
  return (
    <ChromelessButton {...props}>
      <StyledTransparentButtonContentDiv $isBig={isBig}>{children}</StyledTransparentButtonContentDiv>
    </ChromelessButton>
  );
};
